import React, { useEffect } from 'react';
import { ASSETS } from '../assetManifest';

function BoxArt({ app }) {
  return (
    <div
      className="relative h-screen bg-[#000] flex flex-col cursor-pointer"
      style={{
        backgroundImage: `url(${ASSETS.backgrounds.boxArt.path})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
      onClick={() => app.goToMenu()}
    >
      <div className="absolute top-4 right-4">
        <div className="absolute inset-0 bg-white/50 blur-xl rounded-full"></div>
        <img
          src={ASSETS.logos.title.path}
          alt="Logo"
          className="w-48 relative"
        />
      </div>
      <div className="absolute bottom-8 left-0 right-0 flex justify-center gap-8">
        <img
          src={ASSETS.logos.playStore.path}
          alt="Android"
          className="h-16 cursor-pointer"
        />
        <img
          src={ASSETS.logos.appStore.path}
          alt="iOS" 
          className="h-16 cursor-pointer"
        />
      </div>
    </div>
  );
}

export default BoxArt;
